var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoStock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 27,
    fill: "#F3F4F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 36C29.5 36.4945 29.3534 36.9778 29.0787 37.3889C28.804 37.8 28.4135 38.1205 27.9567 38.3097C27.4999 38.4989 26.9972 38.5484 26.5123 38.452C26.0273 38.3555 25.5819 38.1174 25.2322 37.7678C24.8826 37.4181 24.6445 36.9727 24.548 36.4877C24.4516 36.0028 24.5011 35.5001 24.6903 35.0433C24.8795 34.5865 25.2 34.196 25.6111 33.9213C26.0222 33.6466 26.5055 33.5 27 33.5C27.663 33.5 28.2989 33.7634 28.7678 34.2322C29.2366 34.7011 29.5 35.337 29.5 36ZM27 31C27.3978 31 27.7794 30.842 28.0607 30.5607C28.342 30.2794 28.5 29.8978 28.5 29.5V17C28.5 16.6022 28.342 16.2206 28.0607 15.9393C27.7794 15.658 27.3978 15.5 27 15.5C26.6022 15.5 26.2206 15.658 25.9393 15.9393C25.658 16.2206 25.5 16.6022 25.5 17V29.5C25.5 29.8978 25.658 30.2794 25.9393 30.5607C26.2206 30.842 26.6022 31 27 31Z",
    fill: "#65758B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoStock);
export default __webpack_public_path__ + "static/media/no-stock.dbbc0d8ffe554c593ad8d703b8c17c6e.svg";
export { ForwardRef as ReactComponent };